import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/gym/$venueUuid/settings/profile")({
  component: () => <div>Hello /gym/$venueUuid/settings/profile!</div>,
});
